module.exports = __webpack_public_path__ + "static/Kurgastehaus1-fadc9e8af0ea900dedbac61bc9ff7f07.png";